import Image from '@tiptap/extension-image';
import { mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import CustomImageNodeView from '../components/CustomImageNodeView';

export const CustomImageExtension = Image.extend({
  name: 'image',
  draggable: true,

  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      align: {
        default: 'center',
        parseHTML: (element) => {
          return (
            element.getAttribute('data-align') ||
            (element.classList.contains('float-right') || element.style.float === 'right'
              ? 'right'
              : element.classList.contains('float-left') || element.style.float === 'left'
              ? 'left'
              : 'center')
          );
        },
        renderHTML: (attributes) => ({
          'data-align': attributes.align,
        }),
      },
      width: {
        default: '50%',
        parseHTML: (element) => element.getAttribute('data-width') || element.style.width || '50%',
        renderHTML: (attributes) => ({
          'data-width': attributes.width,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span.exam-image-wrapper',
        getAttrs: (element) => ({
          src: element.querySelector('img')?.getAttribute('src') || element.getAttribute('src'),
          alt: element.querySelector('img')?.getAttribute('alt') || element.getAttribute('alt'),
          align: element.getAttribute('data-align') || 'center',
          width: element.getAttribute('data-width') || '50%',
        }),
      },
      {
        tag: 'img[src]',
        getAttrs: (element) => ({
          src: element.getAttribute('src'),
          alt: element.getAttribute('alt'),
          align:
            element.getAttribute('data-align') ||
            (element.style.float === 'right' ? 'right' : element.style.float === 'left' ? 'left' : 'center'),
          width: element.getAttribute('data-width') || element.style.width || '50%',
        }),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const align = HTMLAttributes['data-align'] || 'center';
    const width = HTMLAttributes['data-width'] || '50%';

    let containerStyle = `width: ${width}; max-width: 100%;`;
    let containerClass = 'exam-image-wrapper ';
    let imgStyle = 'width: 100%; max-width: 100%; height: auto; border-radius: 4px; display: block;';

    if (align === 'right') {
      containerStyle += ' float: right; margin: 0 0 12px 16px; display: inline-block;';
      containerClass += 'float-right';
    } else if (align === 'left') {
      containerStyle += ' float: left; margin: 0 16px 12px 0; display: inline-block;';
      containerClass += 'float-left';
    } else {
      containerStyle += ' display: block; margin: 16px auto; text-align: center; clear: both; float: none;';
      containerClass += 'block-center';
    }

    return [
      'span',
      {
        class: containerClass,
        style: containerStyle,
        'data-align': align,
        'data-width': width,
      },
      [
        'img',
        mergeAttributes(HTMLAttributes, {
          style: imgStyle,
          class: 'exam-image',
        }),
      ],
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CustomImageNodeView);
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setImageAlign:
        (align) =>
        ({ commands }) => {
          return commands.updateAttributes('image', { align });
        },
      setImageWidth:
        (width) =>
        ({ commands }) => {
          return commands.updateAttributes('image', { width });
        },
    };
  },
});

export default CustomImageExtension;
